<template>
    <div class="container">
        <div class="">
            <div class="">
                <carousel :per-page="4" :autoplay="true" :autoplaytimeout="6000" :loop="true" class="d-none d-sm-block">
                  <slide v-for="depoimento in depoimentos" :key="depoimento._id">
                    <div>
                      <div class="element-box el-tablo profile-tile-box">
                        <div class="row">

                          <div class="col-sm-4 col-4">
                            <div class="user-avatar">
                              <img alt="" :src="depoimento.clienteImage" class="img-fluid rounded-circle">
                            </div>
                          </div>
                          <div class="col">
                            <div class="label">
                              {{depoimento.nome}}
                            </div>
                            <h6>{{depoimento.descricao}}</h6>
                            <span class="blockquote-footer">
                              {{getDataFormatada(depoimento.createdAt)}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </slide>
                </carousel>
                <carousel :per-page="2" :autoplay="true" :autoplaytimeout="3000" :loop="true" class="d-block d-sm-none">
                  <slide v-for="depoimento in depoimentos" :key="depoimento._id">
                    <div>
                      <div class="element-box el-tablo profile-tile-box">
                        <div class="row">

                          <div class="col-sm-4 col-12 mb-4">
                            <div class="user-avatar">
                              <img alt="" :src="depoimento.clienteImage" class="img-fluid rounded-circle">
                            </div>
                          </div>
                          <div class="col">
                            <div class="label">
                              {{depoimento.nome}}
                            </div>
                            <h6 class="depoimento-txt">{{depoimento.descricao}}</h6>
                            <span class="blockquote-footer">
                              {{getDataFormatada(depoimento.createdAt)}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </slide>
                </carousel>
            </div>
        </div>
    </div>
</template>
<style scoped>
.element-box {
  margin-right: 1rem !important;
}
</style>

<script>
import * as http from 'axios'
import moment from 'moment'

export default {
  data () {
    return {
      depoimentos: []
    }
  },
  async created () {
    const response = await http.get('/drAcheiDepoimentosPublicados')
    this.depoimentos = response.data
  },
  methods: {
    getDataFormatada (date) {
      if (!date) {
        return ''
      }
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/SlickDepoimentos.vue